import script from "./modulePasswordForm.vue?vue&type=script&setup=true&lang=js"
export * from "./modulePasswordForm.vue?vue&type=script&setup=true&lang=js"

import "./modulePasswordForm.vue?vue&type=style&index=0&id=36dd13e9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36dd13e9"]])

export default __exports__